import React from 'react';
import { isRTL } from './formatLocale';
import DefaultTheme from 'react-dates/lib/theme/DefaultTheme';
import { CALENDAR_PRIMARY_BG, CALENDAR_PRIMARY_HOVER_BG, CALENDAR_PRIMARY_FOREGROUND, AVAILABILITY_CALENDAR_DEFAULT_DARK_BG, BLOCKED_DATE_BG, HOVER_SPAN_END_BG, AVAILABILITY_CALENDAR_DEFAULT_BG, BLOCKED_DATE_DARK_FOREGROUND, PASSED_DATE_BG, DARK_PASSED_DATE_BG, CALENDAR_PRIMARY_DARK_FOREGROUND, CALENDAR_PRIMARY_DARK_BG, BLOCKED_DATE_DARK_BG, CALENDAR_PRIMARY_HOVER_DARK_BG, HOVER_SPAN_END_DARK_BG } from '../constants'

const { reactDates: { color } } = DefaultTheme;

export const getCustomizableCalendarStyle = (locale) => {
    const isRtlDirection = isRTL(locale)
    const calenderDirectionLeft = isRtlDirection ? 'right' : 'left';
    const calenderDirectionRight = isRtlDirection ? 'left' : 'right';

    const defaultStyles = {
        background: AVAILABILITY_CALENDAR_DEFAULT_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: AVAILABILITY_CALENDAR_DEFAULT_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const defaultDarkStyles = {
        background: AVAILABILITY_CALENDAR_DEFAULT_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: AVAILABILITY_CALENDAR_DEFAULT_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const outsideStyles = {
        border: `1px solid`,
        color: color.outside.color,
    };

    const outsideDarkStyles = {
        border: `1px solid`,
        color: color.outside.color,
    };

    const highlightedCalendarStyles = {
        background: 'red',
        color: color.highlighted.color,

        hover: {
            background: color.highlighted.backgroundColor_hover,
            color: color.highlighted.color_active,
        },
    };

    const highlightedDarkCalendarStyles = {
        background: 'red',
        color: color.highlighted.color,

        hover: {
            background: color.highlighted.backgroundColor_hover,
            color: color.highlighted.color_active,
        },
    };

    const blockedMinNightsStyles = {
        background: CALENDAR_PRIMARY_HOVER_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: CALENDAR_PRIMARY_HOVER_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const blockedDarkMinNightsStyles = {
        background: CALENDAR_PRIMARY_HOVER_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: CALENDAR_PRIMARY_HOVER_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const blockedCalendarStyles = {
        background: BLOCKED_DATE_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: BLOCKED_DATE_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const blockedDarkCalendarStyles = {
        background: BLOCKED_DATE_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: BLOCKED_DATE_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const blockedStartCalendarStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, transparent 50%), ${BLOCKED_DATE_BG}`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, transparent 50%), ${BLOCKED_DATE_BG}`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const blockedDarkStartCalendarStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, transparent 50%), ${BLOCKED_DATE_DARK_BG}`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, transparent 50%), ${BLOCKED_DATE_DARK_BG}`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const blockedEndCalendarStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, transparent 50%), ${BLOCKED_DATE_BG}`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, transparent 50%), ${BLOCKED_DATE_BG}`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const blockedDarkEndCalendarStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, transparent 50%), ${BLOCKED_DATE_DARK_BG}`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, transparent 50%), ${BLOCKED_DATE_DARK_BG}`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const blockedOutOfRangeStyles = {
        background: PASSED_DATE_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: PASSED_DATE_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const blockedDarkOutOfRangeStyles = {
        background: DARK_PASSED_DATE_BG,
        color: BLOCKED_DATE_DARK_FOREGROUND,
        hover: {
            background: DARK_PASSED_DATE_BG,
            color: BLOCKED_DATE_DARK_FOREGROUND,
        },
    };

    const hoveredSpanStyles = {
        background: CALENDAR_PRIMARY_HOVER_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,

        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${HOVER_SPAN_END_BG} 50%, ${CALENDAR_PRIMARY_BG} 50%)`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const hoveredDarkSpanStyles = {
        background: CALENDAR_PRIMARY_HOVER_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${HOVER_SPAN_END_DARK_BG} 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%)`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const selectedSpanStyles = {
        background: CALENDAR_PRIMARY_HOVER_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,

        hover: {
            background: CALENDAR_PRIMARY_HOVER_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const selectedDarkSpanStyles = {
        background: CALENDAR_PRIMARY_HOVER_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,

        hover: {
            background: CALENDAR_PRIMARY_HOVER_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const lastInRangeStyles = {
        borderRight: color.core.primary,
    };

    const lastInDarkRangeStyles = {
        borderRight: color.core.primary,
    };

    const selectedStyles = {
        background: CALENDAR_PRIMARY_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: CALENDAR_PRIMARY_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const selectedDarkStyles = {
        background: CALENDAR_PRIMARY_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: CALENDAR_PRIMARY_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const selectedStartStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, ${CALENDAR_PRIMARY_BG} 50%)`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom,${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, ${CALENDAR_PRIMARY_BG} 50%)`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const selectedDarkStartStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%)`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%)`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const selectedEndStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_BG} 50%, ${CALENDAR_PRIMARY_BG} 50%)`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_BG}} 50%, ${CALENDAR_PRIMARY_BG} 50%)`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };


    const selectedDarkEndStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%)`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, ${AVAILABILITY_CALENDAR_DEFAULT_DARK_BG} 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%)`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    const blockEndSelectStartStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, transparent 50%, ${CALENDAR_PRIMARY_BG} 50%), ${BLOCKED_DATE_BG}`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom, transparent 50%, ${CALENDAR_PRIMARY_BG} 50%), ${BLOCKED_DATE_BG}`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    }

    const blockEndDarkSelectStartStyles = {
        background: `linear-gradient(to ${calenderDirectionRight} bottom, transparent 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%), ${BLOCKED_DATE_DARK_BG}`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionRight} bottom, transparent 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%), ${BLOCKED_DATE_DARK_BG}`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    }

    const blockStartSelectEndStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, transparent 50%, ${CALENDAR_PRIMARY_BG} 50%), ${BLOCKED_DATE_BG}`,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, transparent 50%, ${CALENDAR_PRIMARY_BG} 50%), ${BLOCKED_DATE_BG}`,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    }

    const blockStartDarkSelectEndStyles = {
        background: `linear-gradient(to ${calenderDirectionLeft} top, transparent 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%), ${BLOCKED_DATE_DARK_BG}`,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: `linear-gradient(to ${calenderDirectionLeft} top, transparent 50%, ${CALENDAR_PRIMARY_DARK_BG} 50%), ${BLOCKED_DATE_DARK_BG}`,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    }

    const blockedSelectedStyles = {
        background: BLOCKED_DATE_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: BLOCKED_DATE_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        }
    }

    const blockedSelectedDarkStyles = {
        background: BLOCKED_DATE_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: BLOCKED_DATE_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        }
    }

    const selectedCheckInDays = {
        background: AVAILABILITY_CALENDAR_DEFAULT_BG,
        color: CALENDAR_PRIMARY_FOREGROUND,
        hover: {
            background: AVAILABILITY_CALENDAR_DEFAULT_BG,
            color: CALENDAR_PRIMARY_FOREGROUND,
        },
    };

    const selectedDarkCheckInDays = {
        background: AVAILABILITY_CALENDAR_DEFAULT_DARK_BG,
        color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        hover: {
            background: AVAILABILITY_CALENDAR_DEFAULT_DARK_BG,
            color: CALENDAR_PRIMARY_DARK_FOREGROUND,
        },
    };

    return {
        defaultStyles, defaultDarkStyles, outsideStyles, outsideDarkStyles, highlightedCalendarStyles, highlightedDarkCalendarStyles, blockedMinNightsStyles, blockedDarkMinNightsStyles, blockedCalendarStyles, blockedDarkCalendarStyles, blockedStartCalendarStyles, blockedDarkStartCalendarStyles, blockedEndCalendarStyles, blockedDarkEndCalendarStyles, blockedOutOfRangeStyles, blockedDarkOutOfRangeStyles, hoveredSpanStyles, hoveredDarkSpanStyles, selectedSpanStyles, selectedDarkSpanStyles, lastInRangeStyles, lastInDarkRangeStyles, selectedStyles, selectedDarkStyles, selectedStartStyles, selectedDarkStartStyles, selectedEndStyles, selectedDarkEndStyles, blockEndSelectStartStyles, blockEndDarkSelectStartStyles, blockStartSelectEndStyles, blockStartDarkSelectEndStyles, blockedSelectedStyles, blockedSelectedDarkStyles, selectedCheckInDays, selectedDarkCheckInDays
    }
}

